export default __webpack_public_path__ + "static/media/profile.a8d98262.svg";